import { tRatingMatrixDocument } from 'services/rating-matrix-document';

export interface DocumentPreparationState {
  isCreatingReports: boolean;
  isLoading: boolean;
  isInit: boolean;
  isDisabledGenerateBtn: boolean;
  data: tRatingMatrixDocument[];
  pagination: {
    page: number;
    totalPages: number;
  };
  error: string | null;
}

export interface Pagination {
  page: number;
  totalPages: number;
}

// Action types
export const DOCUMENT_PREPARATION_ACTIONS = {
  START_PREPARATION: 'documentPreparation/startPreparation',
  START_PREPARATION_SUCCESS: 'documentPreparation/startPreparationSuccess',
  START_PREPARATION_FAILURE: 'documentPreparation/startPreparationFailure',
  
  CHECK_STATUSES: 'documentPreparation/checkStatuses',
  CHECK_STATUSES_SUCCESS: 'documentPreparation/checkStatusesSuccess',
  CHECK_STATUSES_FAILURE: 'documentPreparation/checkStatusesFailure',
  
  SET_PAGE: 'documentPreparation/setPage',
  LOAD_PAGE: 'documentPreparation/loadPage',
  LOAD_PAGE_SUCCESS: 'documentPreparation/loadPageSuccess',
  SET_LOADING: 'documentPreparation/setLoading',
  SET_ERROR: 'documentPreparation/setError',
  
  INIT_MONITORING: 'documentPreparation/initMonitoring',
  START_MONITORING: 'documentPreparation/startMonitoring',
  STOP_MONITORING: 'documentPreparation/stopMonitoring',
  UPDATE_GENERATE_BTN_STATE: 'documentPreparation/updateGenerateBtnState',
} as const;

// Action creators
export const startPreparation = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION,
});

export const startPreparationSuccess = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION_SUCCESS,
});

export const startPreparationFailure = (error: string) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.START_PREPARATION_FAILURE,
  payload: error,
});

export const checkStatuses = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES,
});

export const checkStatusesSuccess = (data: tRatingMatrixDocument[], totalPages: number) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES_SUCCESS,
  payload: { data, totalPages },
});

export const checkStatusesFailure = (error: string) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.CHECK_STATUSES_FAILURE,
  payload: error,
});

export const setPage = (page: number) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.SET_PAGE,
  payload: page,
});

export const loadPage = (page: number) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.LOAD_PAGE,
  payload: page,
});

export const loadPageSuccess = (data: tRatingMatrixDocument[], totalPages: number) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.LOAD_PAGE_SUCCESS,
  payload: { data, totalPages },
});

export const setLoading = (isLoading: boolean) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.SET_LOADING,
  payload: isLoading,
});

export const setError = (error: string | null) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.SET_ERROR,
  payload: error,
});

export const initMonitoring = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.INIT_MONITORING,
});

export const startMonitoring = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.START_MONITORING,
});

export const stopMonitoring = () => ({
  type: DOCUMENT_PREPARATION_ACTIONS.STOP_MONITORING,
});

export const updateGenerateBtnState = (isDisabled: boolean) => ({
  type: DOCUMENT_PREPARATION_ACTIONS.UPDATE_GENERATE_BTN_STATE,
  payload: isDisabled,
});

// Action types
export type DocumentPreparationAction =
  | ReturnType<typeof startPreparation>
  | ReturnType<typeof startPreparationSuccess>
  | ReturnType<typeof startPreparationFailure>
  | ReturnType<typeof checkStatuses>
  | ReturnType<typeof checkStatusesSuccess>
  | ReturnType<typeof checkStatusesFailure>
  | ReturnType<typeof setPage>
  | ReturnType<typeof loadPage>
  | ReturnType<typeof loadPageSuccess>
  | ReturnType<typeof setLoading>
  | ReturnType<typeof setError>
  | ReturnType<typeof initMonitoring>
  | ReturnType<typeof startMonitoring>
  | ReturnType<typeof stopMonitoring>
  | ReturnType<typeof updateGenerateBtnState>;
